// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { DdjDocument } from '@interfaces/document.interfaces';
import { Observable } from 'rxjs';
import { DealsService } from '@services/deals.service';
import { DocumentsService } from '@services/documents.service';

@Injectable({ providedIn: 'root' })
export class PddjResolverService implements Resolve<DdjDocument[]> {
    constructor(
        private readonly dealsService: DealsService,
        private readonly documentsService: DocumentsService
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<DdjDocument[]> {
        if (!route.params.dealId) {
            return null;
        }

        return this.documentsService.getDocsList$(route.params.dealId);
    }
}
